import * as React from 'react';

import { useDebounce } from '@uidotdev/usehooks';

export const useSearchTerm = (timeout = 300) => {
  const [searchTerm, setSearchTerm] = React.useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, timeout);

  return { searchTerm, setSearchTerm, debouncedSearchTerm };
};
